import { createApp } from 'vue'
import App from './App.vue'

import { xApp } from 'xumm-xapp-sdk'

const app = createApp(App)

app.config.globalProperties.$xapp = new xApp()
app.mount('#app')
